import { Icon } from 'idea-react';
import { FC } from 'react';
import { Card } from 'react-bootstrap';

import { t } from '../model/Translation';

export interface StatisticCardProps {
    title: string;
    value: number | string;
    icon: string;
    color: string;
    change?: string;
    changeType?: 'increase' | 'decrease';
}

export const StatisticCard: FC<StatisticCardProps> = ({
    title,
    value,
    icon,
    color,
    change,
    changeType
}) => (
    <Card className="h-100">
        <Card.Body className="d-flex align-items-start">
            <div className="flex-grow-1">
                <div className="text-muted mb-2">{title}</div>
                <h3 className="mb-1">{value}</h3>
                {change && (
                    <small
                        className={
                            changeType === 'increase'
                                ? 'text-success'
                                : 'text-danger'
                        }
                    >
                        <Icon
                            name={
                                changeType === 'increase'
                                    ? 'arrow-up'
                                    : 'arrow-down'
                            }
                        />{' '}
                        {change} {t('compare_last_month')}
                    </small>
                )}
            </div>
            <Icon className={`text-${color}`} name={icon} size={2} />
        </Card.Body>
    </Card>
);
